import React from 'react';
import PropTypes from 'prop-types';
import { push as pushAction } from 'react-router-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import pdf from './assets/Accenture_app_instructions.pdf';

import GDPRpopup from './components/GDPRpopup';

import './App.css';

const GDPRpopupText = {
    text: `This web site is using Cookies and Google Analytics. 
    If you agree to collect statistic data, please mark the checkbox Performance cookies and confirm with button OK. You may review our Cookies Policy `,
    checkboxText: 'Performance cookies'
};

export class App extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isBurgerOpened: false,
            cssClass: props.location.pathname === '/' ? 'hideMenuBkg' : 'showMenuBkg'
        };
    }

    componentDidMount = () => {
        window.addEventListener('scroll', this.handleScroll);

        // Show menu background on page refresh if required
        setTimeout(() => {
            const percentage = window.scrollY / window.innerHeight;
            if (percentage > 0.65) {
                return this.setState({ cssClass: 'showMenuBkg' });
            }
        }, 50);
    };

    componentWillReceiveProps = (nextProps, prevProps) => {
        // Show menu background on route transition if not / or not on landing page view
        if (
            (prevProps.location && nextProps.location.pathname !== prevProps.location.pathname) ||
            !prevProps.location
        ) {
            const percentage = window.scrollY / window.innerHeight;
            this.setState({
                cssClass:
                    nextProps.location.pathname !== '/' || percentage > 0.65
                        ? 'showMenuBkg'
                        : 'hideMenuBkg'
            });
        }
    };

    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.handleScroll);
    };

    onMenuItemClickHandler = event => {
        this.props.pushAction(event.currentTarget.name);
        this.setState({ isBurgerOpened: false });
        window.scrollTo(0, 0);
    };

    onBurgerClickHandler = () => {
        const { isBurgerOpened } = this.state;
        this.setState({ isBurgerOpened: !isBurgerOpened });
    };

    handleScroll = () => {
        if (this.props.location.pathname === '/') {
            const scrollY = window.scrollY || window.pageYOffset;
            const percentage = scrollY / window.innerHeight;

            if (percentage > 0.65) {
                return this.setState({ cssClass: 'showMenuBkg' });
            }
            if (percentage < 0.8) {
                return this.setState({ cssClass: 'hideMenuBkg' });
            }
        }
    };

    render() {
        const { cssClass, isBurgerOpened } = this.state;
        const { location, children } = this.props;
        const { pathname } = location;
        return (
            <div className="App">
                <nav className={`navbar is-fixed-top ${cssClass}`}>
                    <div className="container">
                        <div className="navbar-brand">
                            <div className="navbar-start">
                                <button
                                    className={`navbar-burger burger ${
                                        isBurgerOpened ? 'is-active' : ''
                                    }`}
                                    data-target="navMenu"
                                    onClick={this.onBurgerClickHandler}
                                    type="button"
                                >
                                    <i className="fas fa-bars" />
                                </button>
                            </div>
                            <div className="social-buttons">
                                {/* <a
                                    className="navbar-item"
                                    href="https://twitter.com/OpenSlava"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <i aria-hidden="true" className="fab fa-twitter" />
                                </a> */}
                                <a
                                    className="navbar-item"
                                    href="https://www.facebook.com/OpenSlava"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <i aria-hidden="true" className="fab fa-facebook-f" />
                                </a>
                                <a
                                    className="navbar-item"
                                    href="https://www.linkedin.com/groups/12017066"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <i aria-hidden="true" className="fab fa-linkedin-in" />
                                </a>
                            </div>
                        </div>

                        <div
                            className={`navbar-menu ${isBurgerOpened ? 'is-active' : ''}`}
                            id="navMenu"
                        >
                            <div className="navbar-start">
                                <button
                                    className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/' ? 'menu-item-active' : ''}`}
                                    name="/"
                                    onClick={this.onMenuItemClickHandler}
                                    type="button"
                                >
                                    {isBurgerOpened ? 'Home' : <i className="fas fa-home" />}
                                </button>
                                <button
                                    className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/ff' ? 'menu-item-active' : ''}`}
                                    name="/ff"
                                    onClick={this.onMenuItemClickHandler}
                                    type="button"
                                >
                                    Feedback Form
                                </button>

                                <button
                                    className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/program' ? 'menu-item-active' : ''}`}
                                    name="/program"
                                    onClick={this.onMenuItemClickHandler}
                                    type="button"
                                >
                                    Program
                                </button>
                                <button
                                    className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/workshops' ? 'menu-item-active' : ''}`}
                                    name="/workshops"
                                    onClick={this.onMenuItemClickHandler}
                                    type="button"
                                >
                                    Hands-on Labs
                                </button>
                                <button
                                    className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/speakers' ? 'menu-item-active' : ''}`}
                                    name="/speakers"
                                    onClick={this.onMenuItemClickHandler}
                                    type="button"
                                >
                                    Speakers
                                </button>
                                <button
                                    className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/contacts' ? 'menu-item-active' : ''}`}
                                    name="/contacts"
                                    onClick={this.onMenuItemClickHandler}
                                    type="button"
                                >
                                    Contacts
                                </button>
                                <button
                                    className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/location-map' ? 'menu-item-active' : ''}`}
                                    name="/location-map"
                                    onClick={this.onMenuItemClickHandler}
                                    type="button"
                                >
                                    Location Map
                                </button>
                                <a
                                    className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}`}
                                    href={pdf}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    Mobile App Info
                                </a>
                                <a
                                    className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}`}
                                    href="https://www.openslava.sk/2018"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    2018
                                </a>
                            </div>

                            {!isBurgerOpened && (
                                <div className="navbar-end">
                                    <a
                                        className="navbar-item"
                                        href="https://twitter.com/OpenSlava"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        <i aria-hidden="true" className="fab fa-twitter" />
                                    </a>
                                    <a
                                        className="navbar-item"
                                        href="https://www.facebook.com/OpenSlava"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        <i aria-hidden="true" className="fab fa-facebook-f" />
                                    </a>
                                    <a
                                        className="navbar-item"
                                        href="https://www.linkedin.com/groups/12017066"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        <i aria-hidden="true" className="fab fa-linkedin-in" />
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </nav>
                {children}
                <GDPRpopup checkboxText={GDPRpopupText.checkboxText} text={GDPRpopupText.text} />
            </div>
        );
    }
}

App.propTypes = {
    children: PropTypes.node.isRequired,
    location: PropTypes.objectOf(PropTypes.string).isRequired,
    pushAction: PropTypes.func.isRequired
};

export const mapStateToProps = () => ({});

export const mapActionCreators = {
    pushAction
};

export default withRouter(
    connect(
        mapStateToProps,
        mapActionCreators
    )(App)
);
